export default __webpack_public_path__ + "static/9-57ec669ec2867aefd737fdf5fc2cfe31.png";